module.exports = __webpack_public_path__ + "img/IMG_1867_L_Foamcore_MockedUp.442eeef2.jpg";